import colorPalette from '../color-palette';

const { info } = colorPalette;

export default {
  MuiDivider: {
    root: {
      width: '45%',
      marginTop: '11px',
      backgroundColor: info.divider,
    },
  },
};
